import {RouteLocationRaw} from 'vue-router';

interface QueryTargetRoute {
    page?: 'login' | 'address' | string;
    [key: string]: any;
}

export function resolveQueryPageRoute(query: QueryTargetRoute): undefined | RouteLocationRaw {

    switch (query.page) {
        case 'login':
            return {
                name: 'tunnel.loginVerification',
                query
            }
        case 'address':
            return {
                name: 'tunnel.addressVerification',
                query
            }

        default:
            return undefined;
    }
}